<template>
  <v-container>
    <v-form ref="form" @submit.prevent="onSubmit">
      <v-row v-for="tlc in teamLevelCriteria">
        <v-col>{{ tlc.team_level }}</v-col>
        <v-col>
          <v-text-field
            v-model="tlc.criteriaCounts[0].mandatory_number"
            label="Mandatory #"
            type="number"
            :rules="[rules.postiveNumber]" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn
            type="submit"
            :loading="isSubmitting"
            block
            class="rounded-lg mb-8"
            elevation="2"
            color="primary"
            >Save</v-btn
          >
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>
<script setup lang="ts">
import { ITeamLevelDTO, TeamLevelDTO } from '@/dtos';
import { useCriteriaStore, useUpdateStatusStore } from '@/stores';
import { computed, ref, watch } from 'vue';
import { rules } from '@/helpers';
import type { VForm } from 'vuetify/components';
import { SNACKSTATUS } from '@/stores/util';

interface Props {
  yearId: string;
}
const props = defineProps<Props>();
const yearId = computed(() => props.yearId);
const isSubmitting = ref<boolean>(false);
const form = ref<InstanceType<typeof VForm> | null>();
const criteriaStore = useCriteriaStore();
const statusStore = useUpdateStatusStore();
const teamLevelCriteria = ref<ITeamLevelDTO[]>([]);
const { data: criteriaTeamLevelData } = criteriaStore.getCriteriaCountForTeamLevels(yearId);

const emit = defineEmits(['snack']);
watch(criteriaTeamLevelData, () => {
  if (criteriaTeamLevelData.value?.data) {
    teamLevelCriteria.value = criteriaTeamLevelData.value.data.map(
      (selected) => new TeamLevelDTO(selected),
    );
  }
});
const key = computed(() => `criteria-year-team-levels-${yearId.value}`);

watch(
  () => statusStore.getStatus(key.value),
  (value: SNACKSTATUS | undefined) => {
    if (!value) {
      return;
    }
    emit('snack', 'Team Criteria', value, statusStore.getError(key.value));
    isSubmitting.value = false;
  },
);

const onSubmit = async () => {
  if (!form.value) {
    return;
  }
  isSubmitting.value = true;

  criteriaStore.saveTeamLevelCriteria.mutateAsync({
    yearId: yearId.value,
    teamLevelCriteria: teamLevelCriteria.value,
  });
};
</script>
